import { useMenu } from 'context/MenuContext';
import { useEffect, useState } from 'react';
import styles from './styles.module.scss';

type HamburgerButton = {
  isOpen: boolean;
  onClick: () => void;
}

function HamburgerButton(props : HamburgerButton) : JSX.Element {
  const { isUndefined, fetchMenu } = useMenu();
  const [change, animateButton] = useState('');

  const openNav = () : void => {
    let timeoutTime = 0;

    if(isUndefined()) {
      fetchMenu();
      timeoutTime = 2000;
    }

    setTimeout(() => {
      if(isUndefined())
        return;

      animateButton(x => x === '' ? styles.change : '');
      props.onClick();
    }, timeoutTime);
  };

  useEffect(() => {
    if (!props.isOpen)
      animateButton('');

  }, [props.isOpen]);

  return(
    <div
      id={styles['biobar-menu-button']}
      className={change}
      onClick={openNav}
    >
      <button>
        <div className={styles.bar1}></div>
        <div className={styles.bar2}></div>
        <div className={styles.bar3}></div>
      </button>
    </div>
  );

}

export default HamburgerButton;